$(document).ready(function () {


    document.querySelectorAll('[data-slider-config]').forEach(slider => {
      const config = JSON.parse(slider.dataset.sliderConfig);

      if (!$(slider).hasClass('slick-initialized')) {
        $(slider).slick(config);
      }
    });

});

 $(document).on("click", ".el-play-button", function (e) {
     var video = jQuery(this).parents('.el-video-wrapper').find('video');
 if (jQuery(this).hasClass("active")) {
    jQuery(this).parents('.el-video-wrapper').removeClass('el-active');
     jQuery(this).removeClass('active');
 video.trigger('pause');
 } else {
 video.trigger('play');
   jQuery(this).parents('.el-video-wrapper').addClass('el-active');
     jQuery(this).addClass('el-active');
 }
 });



 
jQuery(document).ready(function(){
if(navigator.userAgent.indexOf('Mac') > 0) {
jQuery('body').addClass('mac-os');
} else {
jQuery('body').addClass('window-os');
}
});

$(window).on('scroll', function () {
  let scrollTop = $(this).scrollTop();

  if (scrollTop > 30) {
    $('body').addClass('remove_transparent');
  } else {
    $('body').removeClass('remove_transparent');
  }
});



$(document).on("click", ".el-question", function (e) {
  if (jQuery(this).hasClass("el-active")) {
    jQuery(this).toggleClass('el-active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.el-question').removeClass('el-active');
    jQuery('.el-question').next().slideUp();
    jQuery(this).toggleClass('el-active');
    jQuery(this).next().slideToggle();
  }
});


$(document).on("click", "a[href='/#faq']", function (e) {
  const target = document.querySelector('.el-faq');

  if (target) {
    e.preventDefault();
    target.scrollIntoView({
      behavior: 'smooth'
    });
  }
  // else: do nothing → browser follows the link normally
});
$(document).on("click", "a[href='#reviews']", function (e) {
  e.preventDefault();
  document.querySelector('#reviews').scrollIntoView({
    behavior: 'smooth'
  })
});

$(document).on("click", "a[href='#']", function (e) {
  e.preventDefault();
  document.querySelector('.el-product').scrollIntoView({
    behavior: 'smooth'
  })
});

$(document).on("click", ".el-mobile-menu-button", function (e) {
    $('.el-drawer-menu').addClass('active');
    $('.el-drawer-menu-bg').show();
    $('body').addClass('el-overflow-hidden');
});
$(document).on("click", ".el-mobile-menu-close", function (e) {
    $('.el-drawer-menu').removeClass('active');
    $('.el-drawer-menu-bg').hide();
    $('body').removeClass('el-overflow-hidden');
});

$(document).on("click", ".el-drawer-menu-bg", function (e) {
    $('.el-drawer-menu').removeClass('active');
    $('.el-drawer-menu-bg').hide();
    $('body').removeClass('el-overflow-hidden');
});













$(document).on("click", ".el-cart-button", function (e) {
    location.href="/cart";
});





 
jQuery(document).ready(function(){
if(navigator.userAgent.indexOf('Mac') > 0) {
jQuery('body').addClass('mac-os');
} else {
jQuery('body').addClass('window-os');
}
});



 
jQuery(document).ready(function(){
$('.el-pdp-tab .el-element-text ul li:first-child').addClass('el-active');
});



$(document).on("click", ".el-pdp-solution-tab ul li", function (e) {
  e.preventDefault();
  $('.el-pdp-solution-tab ul li').removeClass('el-active');
  $(this).addClass('el-active');
  var index = parseInt($(this).index())+1;
  $('.el-pdp-solution-list').removeClass('el-active');
  $('.el-pdp-solution-list'+index).addClass('el-active');
});

$(document).on("click", ".el-pdp-formula-tab ul li", function (e) {
  e.preventDefault();
  $('.el-pdp-formula-tab ul li').removeClass('el-active');
  $(this).addClass('el-active');
  var index = parseInt($(this).index())+1;
  $('.el-pdp-formula-list').removeClass('el-active');
  $('.el-pdp-formula-list'+index).addClass('el-active');
});


$(document).on("click", "a[href='#show']", function (e) {
  e.preventDefault();
  $('.el-pdp-review2-list1-item:nth-child(3)~.el-pdp-review2-list1-item').slideDown();
  $('.el-pdp-review2-links:has(a[href="#show"])').hide();
  $('.el-pdp-review2-links:has(a[href="#hide"])').show();
});
$(document).on("click", "a[href='#hide']", function (e) {
  e.preventDefault();
  $('.el-pdp-review2-list1-item:nth-child(3)~.el-pdp-review2-list1-item').slideUp();
  $('.el-pdp-review2-links:has(a[href="#hide"])').hide();
  $('.el-pdp-review2-links:has(a[href="#show"])').show();
});














  function refreshAndOpenRebuyCart2() {
  if (!window.Rebuy) return;

  Rebuy.Cart.fetch();       // refresh data
  Rebuy.SmartCart.show();   // open drawer
}

$(document).on("click", ".el-cart-button", function (e) {
    refreshAndOpenRebuyCart2();
});
// MAIN OPTION CLICK
$(document).on('click', '.el-product .el-element-option', function () {
  var $this = $(this);
  var $parent = $this.closest('.el-product');
  var tab = parseInt($this.attr('data_tab'), 10);

  if (!tab) return;

  // Active state
  $parent.find('.el-element-option').removeClass('el-active');
  $this.addClass('el-active');

  // Toggle quantity UI
  $parent.find('.el-quantity-trigger').hide();
  $parent.find('.el-quantity-trigger[data_tab="' + tab + '"]').show();

  $parent.find('.el-checkout-button').attr('quantity',tab);
 
});


// SUB OPTION CLICK (when NOT active)
$(document).on('click', '.el-product .el-element-sub-option:not(.el-active)', function () {
  var $this = $(this);
  var $parent = $this.closest('.el-product');
  var tab = parseInt($this.attr('sub_tab'), 10);
  var selling_plan = $this.attr('selling_plan');

  if (!tab) return;

  // Active state
  $parent.find('.el-element-sub-option').removeClass('el-active');
  $this.addClass('el-active');

  // Toggle UI
  $parent.find('.el-sub-trigger').hide();
  $parent.find('.el-sub-trigger[sub_tab="' + tab + '"]').show();
  $parent.find('.el-checkout-button').attr('selling_plan',selling_plan);
});


// SUB OPTION CLICK (when already active → toggle to other)
$(document).on('click', '.el-product .el-element-sub-option.el-active', function () {
  var $parent = $(this).closest('.el-product');

  var $other = $parent.find('.el-element-sub-option:not(.el-active)');
  var tab = parseInt($other.attr('sub_tab'), 10);

  if (!tab) return;

  // Switch active
  $parent.find('.el-element-sub-option').removeClass('el-active');
  $other.addClass('el-active');

  // Toggle UI
  $parent.find('.el-sub-trigger').hide();
  $parent.find('.el-sub-trigger[sub_tab="' + tab + '"]').show();
  $parent.find('.el-checkout-button').removeAttr('selling_plan');
});





$(window).on('scroll resize', function () {
    const scrollTop = $(window).scrollTop();
    const docHeight = $(document).height() - $(window).height();

    const progress = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;

    $('.lp2-header-bar-inear').css('width', progress + '%');
});

// Trigger once on page load
$(window).trigger('scroll');




$(document).on("click", ".el-lp2-insides-list1-item .el-element-title", function (e) {
    if ($(window).width() >= 915) {
        return;
    }
    const $this = $(this);

    if ($this.hasClass("el-active")) {
        $this.removeClass("el-active");
        $this.next().slideUp();
    } else {
        $(".el-lp2-insides-list1-item .el-element-title").removeClass("el-active");
        $(".el-lp2-insides-list1-item .el-element-title").next().slideUp();

        $this.addClass("el-active");
        $this.next().slideDown();
    }
});



$('.el-lp2-insides-list1-item:first-child .el-element-title').trigger('click');

$(document).on("click", ".el-lp2-number-views .el-icon-with-text-flex", function (e) {
$('.el-lp2new-CAP-popup').addClass('el-active');
});

$(document).on("click", ".el-lp2new-CAP-popup-list1 .el-media.el-svg", function (e) {
$('.el-lp2new-CAP-popup').removeClass('el-active');
});
